module.exports = __webpack_public_path__ + "img/brand.f3ad2db9.png";